// PLAN-cockpit-v2-iter1 Phase 1 追補: Sub-sidebar ↔ Main 境界の drag resize + localStorage 保存
import { useCallback, useEffect, useRef, useState } from 'react'

const STORAGE_KEY = 'cockpit_v2.sub_sidebar_width'
const DEFAULT_WIDTH = 288 // = w-72 = 18rem
const MIN_WIDTH = 200
const MAX_WIDTH = 480

function readStored(): number {
  try {
    const v = parseInt(window.localStorage.getItem(STORAGE_KEY) ?? '', 10)
    return isNaN(v) ? DEFAULT_WIDTH : Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, v))
  } catch {
    return DEFAULT_WIDTH
  }
}

export function useSubSidebarResize() {
  const [width, setWidth] = useState<number>(readStored)
  const dragging = useRef(false)
  const startX = useRef(0)
  const startWidth = useRef(0)

  const onDragHandleMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault()
    dragging.current = true
    startX.current = e.clientX
    startWidth.current = width
    document.body.style.cursor = 'col-resize'
    document.body.style.userSelect = 'none'
  }, [width])

  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      if (!dragging.current) return
      // Sub-sidebar は左、右ドラッグで幅増 (Detail とは符号が逆)
      const delta = e.clientX - startX.current
      const next = Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, startWidth.current + delta))
      setWidth(next)
    }
    const onMouseUp = () => {
      if (!dragging.current) return
      dragging.current = false
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
      setWidth(w => {
        try { window.localStorage.setItem(STORAGE_KEY, String(w)) } catch { /* ignore */ }
        return w
      })
    }
    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
    return () => {
      window.removeEventListener('mousemove', onMouseMove)
      window.removeEventListener('mouseup', onMouseUp)
    }
  }, [])

  const reset = useCallback(() => {
    setWidth(DEFAULT_WIDTH)
    try { window.localStorage.setItem(STORAGE_KEY, String(DEFAULT_WIDTH)) } catch { /* ignore */ }
  }, [])

  return { width, onDragHandleMouseDown, reset }
}
